import { Fragment } from 'preact';
import { useState } from 'preact/hooks';
import { load, abort } from '@/app';
import { getConfig, getDebugEnabled } from '@/config';
import { css } from '../styles';
import { clearStorage } from '@/storage';
import Deployment from './Deployment';
import ToggleButton from './ToggleButton';
import Box from './Box';
import SearchBar from './SearchBar';
import RefreshButton from './RefreshButton';
import ChevronRightIcon from './ChevronRightIcon';
import Logo from './Logo';

export default function Assistant({ exit = () => {} }) {
	const [open, setOpen] = useState(false);
	const [searchValue, setSearchValue] = useState('');
	const [render, setRender] = useState(0);

	const refresh = () => {
		clearStorage();
		Object.keys(getConfig(config => config.deployments)).forEach(deploymentKey => {
			const deployment = getConfig(config => config.deployments[deploymentKey]);
			abort(deployment.id);
			setRender(state => state + 1);
			load(deployment.id);
		});
	};

	return (
		<Fragment>
			<link rel="stylesheet" href="https://fonts.mopinion.com/css?family=Open+Sans:400,600" />
			<style>{css}</style>
			<Box name="drawer" classes={open ? ['open'] : []}>
				<Box name="inner">
					<ToggleButton open={open} onClick={() => setOpen(prev => !prev)} />
					<Box name="header">
						<Box name="flexer">
							<Box name="icon-button" onClick={() => setOpen(prev => !prev)}>
								<ChevronRightIcon />
							</Box>
							<Logo />
							<Box name="title">Deployment Assistant</Box>
						</Box>
						<Box name="abort" classes={['btn-link']} component="button" onClick={exit}>
							Exit Assistant
						</Box>
					</Box>
					<Box name="content">
						<Box name="actions">
							<SearchBar value={searchValue} onInput={e => setSearchValue(e.target.value)} />
							<RefreshButton onClick={refresh} />
						</Box>
						{Object.keys(getConfig(config => config.deployments))
							.filter(deploymentKey => getDebugEnabled(deploymentKey))
							.map(deploymentKey => {
								const deployment = getConfig(config => config.deployments[deploymentKey]);
								return (
									<Deployment
										key={deploymentKey + render}
										searchValue={searchValue}
										deployment={deployment}
										toggleDrawer={() => setOpen(prev => !prev)}
										refresh={refresh}
									/>
								);
							})}
					</Box>
				</Box>
			</Box>
		</Fragment>
	);
}
